import { SelectOptionType } from '@octano/global-ui';
import { Institution } from '../../../../Configurations/Institutions/interfaces/type';
interface DegreeLevels {
  id: number;
  name: string;
  type: string;
  createdAt: string;
  updatedAt: string;
}

interface SpecialtyType {
  id: string;
  name: string;
  order: number;
  createdAt: string;
  updatedAt: string;
}

interface LinkedFile {
  id: number;
  name: string;
  extension: string;
  type: string;
  uploadedById: number;
  fileUrl?: string;
}
export interface EducationRecordFile<T = LinkedFile> {
  code: string;
  fileUrl?: string;
  linkedFile: T;
}

export interface EducationRecord {
  id: number;
  teacherId: number;
  name: string;
  dateOfIssue: string;
  description: string;
  originInstituteCustom: string | null;
  isRecognized: boolean;
  institutionId: number | null;
  specialtyTypeId: string | null;
  institution?: Institution;
  studyCarriedOut: string;
  country: SelectOptionType;
  degreeLevel: DegreeLevels;
  specialtyType: SpecialtyType | null;
  files: EducationRecordFile[];
  type: string;
}

export interface EducationalBackgroundResponse {
  academicDegrees: EducationRecord[];
  specialties: EducationRecord[];
  certificates: EducationRecord[];
}

export interface TeacherEducationalBackgroundSettingInterface {
  code: string;
  name: string;
  required: EducationalBackgroundType[];
  visible: EducationalBackgroundType[];
}
export interface EducationalBackgroundFormDataResponse {
  defaultCountry?: string;
  requiredFiles: TeacherEducationalBackgroundSettingInterface[];
  degreeLevels: SelectOptionType[];
  specialtiesTypes: SelectOptionType[];
  specialtyLevels: SelectOptionType[];
  countries: SelectOptionType[];
  institutions: SelectOptionType[];
}

export enum EducationalBackgroundType {
  AcademicDegree = 'grados',
  Specialty = 'especialidades',
  Certificate = 'certificados',
}

export interface FormDataAction {
  name: string;
  originInstituteCustom: string | null;
  institutionId: number | null;
  dateOfIssue: Date;
  studyCarriedOut: string;
  description: string;
  countryId: string | number | undefined;
  isRecognized: boolean;
  degreeLevelId: number | undefined;
  specialtyTypeId: string | undefined;
  files: EducationRecordFile<File>[];
  type: string;
}
